
<div [class.hmf-display-none]="!affirmPayLaterEnabled">
  <p
  class="affirm-as-low-as hmf-mb-0 hmf-p-0"
  [attr.data-page-type]="page"
  [attr.data-amount]="price"
  >
</p>
</div>

